import type { JSX } from 'solid-js';
import { t } from '../i18n';
import { Field } from './Field';

// How long an invited person's grant lasts (plan 102 slice 05): whole days from the
// moment it is granted, or ONGOING — no end date, sent as `expires_in_days: null`
// (`InviteExpiresInDaysSchema`, `@developerz/domain`). Presenter for both invite
// doors' forms (`AdminInviteForm`, `AdminInviteByEmailForm`); each owns its signals.
// Ticking ongoing disables the days input rather than clearing it, so unticking
// gives the operator back the number they had.

export function AdminGrantDuration(props: {
  /** Element id namespace — two forms may be mounted at once. */
  readonly id: string;
  readonly busy: boolean;
  readonly days: string;
  readonly ongoing: boolean;
  readonly onDays: (value: string) => void;
  readonly onOngoing: (on: boolean) => void;
}): JSX.Element {
  return (
    <>
      <Field
        label={t('admin.access_field_expires')}
        id={`${props.id}-expires`}
        desc={t('admin.access_field_expires_desc')}
      >
        {(a11y) => (
          <input
            {...a11y}
            class="input"
            type="number"
            min="1"
            step="1"
            disabled={props.busy || props.ongoing}
            value={props.days}
            onInput={(e) => props.onDays(e.currentTarget.value)}
          />
        )}
      </Field>
      <label class="admin-detail__check">
        <input
          type="checkbox"
          checked={props.ongoing}
          disabled={props.busy}
          onChange={(e) => props.onOngoing(e.currentTarget.checked)}
        />
        {t('admin.access_field_ongoing')}
      </label>
    </>
  );
}
